/** Returns the value to write, or undefined if no write should happen. */
export function decideFirstTouch(
  current: string | undefined,
  next: string | undefined,
): string | undefined {
  if (!next) return undefined;
  if (current) return undefined;
  return next;
}

/** Returns the value to write, or undefined if no write should happen. */
export function decideLastTouch(
  _current: string | undefined,
  next: string | undefined,
): string | undefined {
  if (!next) return undefined;
  return next;
}
